import _taggedTemplateLiteral from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

// ignore-string-localization
import React from 'react';
import styled, { ThemeProvider, createGlobalStyle } from 'styled-components';
import LegacyFooter from '../../legacy/root/Footer';
import { Banners } from '../../@mrkt/features/Banner/Banners';
import { NavBar } from './Nav/NavBar';
import { USE_FRODOR_FOOTER } from './Nav/constants';
import { getLinkStyle } from '../ui';
import { darkTheme } from '../Theme';
import { Footer } from './Footer';
import { Main } from './Main';
import { useRouteBanners } from './useRouteBanners';
import { useLayoutContext } from './LayoutState';
import { PreviewLink } from './PreviewLink';
import { useRouter } from 'next/router';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LayoutContainer = styled.div.withConfig({
  displayName: "Layout__LayoutContainer",
  componentId: "m21fam-0"
})(["display:flex;flex-direction:column;position:absolute;top:0;left:0;min-height:100%;width:100%;background:", ";color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.layout.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.layout.text;
});
var FooterComponent = USE_FRODOR_FOOTER && Footer || LegacyFooter; // terrible hack to override some bootstrap *&^# for now

var UndoLegacyStyles = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .footer-default .nav a {\n    ", "\n  }\n"])), function (props) {
  return getLinkStyle(props);
});
export var Layout = function Layout(_ref3) {
  var children = _ref3.children;

  var _useLayoutContext = useLayoutContext(),
      showNavBar = _useLayoutContext.showNavBar,
      showFooter = _useLayoutContext.showFooter,
      isPreview = _useLayoutContext.isPreview;

  var router = useRouter();
  useRouteBanners(); // plain mode: shows no nav/footer to comply with apple terms of service
  // when linked from the mobile app

  var plainMode = ('plain' in (router.query || {}));
  return /*#__PURE__*/_jsxs(ThemeProvider, {
    theme: darkTheme,
    children: [/*#__PURE__*/_jsxs(LayoutContainer, {
      children: [!plainMode && showNavBar && /*#__PURE__*/_jsx(NavBar, {}), /*#__PURE__*/_jsx(Banners, {}), /*#__PURE__*/_jsx(Main, {
        children: children
      }), !plainMode && showFooter && /*#__PURE__*/_jsx(FooterComponent, {}), isPreview && true && /*#__PURE__*/_jsx(PreviewLink, {})]
    }), /*#__PURE__*/_jsx(UndoLegacyStyles, {})]
  });
};